import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import i18n from 'i18next';

import { Avatar } from 'uikit/avatars';
import { Typo } from 'uikit/content';
import { addModal, handleAxiosError } from 'core/notifications';
import { Button } from 'uikit/buttons';

import styles from '../styles/videoSpeakers.module.scss';
import Profile from '../../profile/components/profile';

const VideoSpeakers = ({ speakers }) => {
  const handleProfileClick = async (profileUrl) => {
    try {
      const { data } = await axios.get(`/api/learner/profile?profile_url=${profileUrl}`);
      addModal({
        id: 'speakerProfile',
        component: (
          <Profile
            profile={data.data}
            isCurrentUser={false}
            className="profileModal"
            isReputationEnabled
            isSpeakerProfile
          />
        ),
        hasCloseButton: true,
        closeButtonColor: 'secondary',
      });
    } catch (error) {
      handleAxiosError(error);
    }
  };

  return (
    <div className={styles.container}>
      <Typo className={styles.title} variant="d02">
        {i18n.t('speakers')}
      </Typo>
      <div className={styles.element}>
        {speakers.map(({ id, name, picture, profile_url: profileUrl }) => (
          <div className={styles.speaker} key={id}>
            <Button
              className={styles.speakerButton}
              onClick={() => handleProfileClick(profileUrl)}
              text={name}
              variant="ghost"
              size="small"
            >
              <Avatar avatar={picture?.thumb} name={name} size="large" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

VideoSpeakers.propTypes = {
  speakers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      picture: PropTypes.shape({ thumb: PropTypes.string }),
      profile_url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default React.memo(VideoSpeakers);
